<template>
    <div>
      <span v-if="debug === 'true' || debug === true">{{version}}</span>
      <div v-if="$localStorageService.can('BE_CAM_EE') || resource.permiteCambiarDiagnosticador" >
          <b-form-select
                  class="parrafos"
                  size="sm parrafos"
                  v-model="data.item.idEmpleadoEmbajador"
                  @change="putAsignarEncargadoSolicitud($event, data.item.idSolicitudEtapa)">
              <b-form-select-option
                      v-for="(elemento, i) in resource.arrayDoctorEmbajador"
                      :key="elemento.idEmpleado  + data.item.idSolicitudDiagnostico + i"
                      :value="elemento.idEmpleado"

              >{{ elemento.nombreEmpleado }}</b-form-select-option>
          </b-form-select>
      </div>
      <div v-else class="parrafos letraMayusculaMinuscula">
          <p>{{ data.item.nombreEmbajador }}</p>
      </div>
    </div>

</template>

<script>
    export default {
        name: "BandejaEmbajadorComponente",
        props: {
            data: Object,
            resource: Object
        },
      data: () => ({
        version: process.env.VUE_APP_ENV_VERSION,
        debug: false,
      }),
      created(){
        this.debug = this.$localStorageService.getDebug();
      },
        methods: {
            putAsignarEncargadoSolicitud(empleado, idSolicitud) {
            this.loading = true;
                var params = {
                    idEmpleado: empleado,
                    idSolicitudDiagnostico: idSolicitud,
                    idUsuarioLogueado: this.$localStorageService.getIdUsuario()
                };
                this.$http
                    .put( this.$api + "pti/bandeja/embajador/asignarEncargadoSolicitud", params)
                    .then((response) => { 
                        this.$swal.fire({
                        icon: 'success',
                        title: response.data.message
                        }); 
                    })
                    .catch((error) => {
                         this.$swal.fire({
                            icon: "error",
                            title: "Ocurrio un error",
                            text: error.message,
                        }); 
                    });

            },



            
        }
    }
</script>
